import React from 'react'
import PriceFormatter from '../../utils/price-formatter'
import createReactClass from 'create-react-class'


var UpsaleGroupTotal = createReactClass({

   getTotal: function () {
    var total = 0.0;

    for (var i = 0; i < this.props.itemList.length; i++) {
      total += parseFloat(this.props.itemList[i].getPrice(10));
    }

    return Math.round(total*100)/100;
  },
  render: function() {
    return (
      <div className="ope-upsale__group__total">
        {_('Amount')}
        <span className="ope-upsale__group__total__sum">{PriceFormatter(this.getTotal())}</span>
      </div>
    );
  }
});

export default UpsaleGroupTotal;
